import React, { useContext, useEffect } from "react";
import { Modal, Button, Container } from "semantic-ui-react";
import { AppStoreContext } from "../../stores/AppStore";
import { RateStoreContext } from "../../stores/RateStore";
import { GLOBAL_MODALS } from "../../stores/modals";
import { trackAction } from "../../tracking";
import OnboardingActions from "../../tracking/actions";
import { useTranslation } from "react-i18next";
export default function ModalDone() {
  const appStore = useContext(AppStoreContext);
  const rateStore = useContext(RateStoreContext);
  const [t] = useTranslation();
  useEffect(() => {
    trackAction(OnboardingActions.ModalDoneDisplayed)
  }, [])

  let msg = t("rate_done_modal_accept", { amount: rateStore.rateAmount });
  if (rateStore.negotiateDeclined) {
    msg = t("rate_done_modal_declined_message");
  } else if (rateStore.approvalNeeded) {
    msg = t("rate_done_modal_needs_approval_message");
  }

  return (
    <Modal
      defaultOpen={true}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      dimmer="blurring"
      style={{ maxWidth: 400 }}
      size="small"
    >
      <Modal.Content>
        <Container fluid textAlign="center" style={{ padding: "1rem" }}>
          <p>{msg}</p>
          <br />
          <Button
            onClick={() => {
              appStore.globalModal = GLOBAL_MODALS.WHATS_NEXT;
              trackAction(OnboardingActions.global.Click, {from: "modal-done", button: "next"})
            }}
            primary
          >
            {t("next")}
          </Button>
        </Container>
      </Modal.Content>
    </Modal>
  );
}
